import { FC } from "react";

type BinCardShape = {
  id: number;
  name: string;
  price: number;
  defaultPrice?: number;
  bin: string;
  binValue: string;
  network?: string;
  cardType?: string;
  provider?: string;
  needDepositForActiveCard?: boolean;
  needCardHolder?: boolean;
  minDepositAmount?: number;
  maxDepositAmount?: number;
  linesImage?: string;
  noiseImage?: string;
  background?: string;
  logoImage?: string;
  blBlurImage?: string;
  trBlurImage?: string;
  payBadgeBackground?: string;
};

type BinCardProp = {
  card: BinCardShape;
  className?: string;
};

const BinCard: FC<BinCardProp> = ({ card, className }) => {
  const networkLogo =
    card.network === "Visa" ? (
      <img
        src="/images/visa-white.png"
        alt="Visa"
        className="h-4 object-contain"
      />
    ) : card.network === "MasterCard" ? (
      <img
        src="/images/mastercard-logo.svg"
        alt="Mastercard"
        className="h-6 object-contain"
      />
    ) : null;

  const amountBlock = (
    <div className="flex flex-col">
      <span className="text-xl font-semibold text-white">
        {card.defaultPrice != null && card.defaultPrice !== card.price
          ? `${card.price} - ${card.defaultPrice} USD`
          : `${card.price} USD`}
      </span>
      <span className="text-sm font-medium tracking-wide text-white">
        {card.binValue.slice(0, 4)} ****
      </span>
    </div>
  );

  return (
    <div
      className={`font-dm-sans aspect-3/2 w-full overflow-hidden ${className}`}
      style={card.background ? { background: card.background } : undefined}
    >
      {/* The card face is designer artwork; line art, glow and texture are
          baked into it, so there are no decorative overlay layers here. */}
      <div className="relative flex h-full flex-col justify-between">
        <div></div>
        <div className="ml-3 flex w-[32%] justify-end">
          <img
            src={card.logoImage ?? "/images/logo-transparent-light.svg"}
            className="h-auto w-full object-contain"
            alt="logo"
          />
        </div>

        <div className="relative z-10 h-[0%] justify-between px-4 pt-4">
          {/* Width is a percentage of the card, not a fixed px: BinCard is
              rendered at ~410px in Shop but ~300-320px in the creation sheets,
              so a fixed width reads correct in one place and small in another. */}

          <div></div>
          {amountBlock}
        </div>

        <div className="relative z-10 h-[50%] bg-transparent">
          <div className="flex h-full items-center justify-between px-4 pt-2">
            {card.provider === "int" ? (
              <div />
            ) : (
              <div
                className="flex items-center gap-1.5 rounded-full border border-white/20 px-2.5 py-1"
                style={{
                  background:
                    card.payBadgeBackground ??
                    "linear-gradient(90deg, rgba(240, 229, 255, 0.16) 0%, rgba(102, 22, 167, 0.16) 100%)",
                  backdropFilter: "blur(4px)",
                }}
              >
                <img
                  src="/icons/google.png"
                  alt="Google"
                  className="size-[11px] object-contain"
                />
                <img
                  src="/icons/apple.png"
                  alt="Apple"
                  className="size-[11px] object-contain"
                />
                <span className="text-[10px] font-medium text-white">
                  Pay enabled
                </span>
              </div>
            )}
            {networkLogo}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BinCard;
